/**
 * CreateStore queries
 */
import gql from 'graphql-tag'

export const getFeePrices = gql`
  query getFeePrices {
    designReviewPrices: getDesignReviewPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
    testPrintPrices: getTestPrintPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
  }
`

export const getDesignLabInfoQuery = gql`
  query getDesignLabInfo {
    designInfo: getDesignLabInfo(onlyData: true) {
      deliveryDaysPrint: delivery_days_print
      deliveryDaysPhoto: delivery_days_photo
      deliveryDaysReview: delivery_days_review
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CheckoutPrintCheckModal/data.ts